import React from 'react';
import { Button } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';

import customer from '../../../schemas/customer';
import CustomerForm from '../components/CustomerForm/CustomerForm';
import { actions as customerActions } from '../redux/customerActions';
import { connect } from 'react-redux';

const CustomerCreateContainer = ({ createCustomer }) => {
  const handleCreateCustomer = (values) => {
    return createCustomer(values);
  };

  return (
    <InternalContainer
      title="Customer"
      buttons={
        <Button
          bsStyle="default"
          label="Back"
          isBackButton={true}
          leftIcon="caret-left"
        />
      }
    >
      <CustomerForm resource={customer} onSaveCustomer={handleCreateCustomer} />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    createCustomer: customerActions.createCustomer,
  },
)(CustomerCreateContainer);
